import React from "react";
import "./Common_Heading.css";

const CommonHeading = ({ badge, title, description }) => {
  return (
    <div className="common_heading">
      {badge && (
        <span className="common_heading_badge">
          {badge}
        </span>
      )}

      <h2 className="title">{title}</h2>

      {description && (
        <p className="description">{description}</p>
      )}
    </div>
  );
};

export default CommonHeading;
